import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ProfessionalServicePriceType, ProfessionalServiceRessource } from '@adeo/ngx-kozikaza-api/pro/service';

@Component({
  selector: 'app-service-price',
  templateUrl: './service-price.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ServicePriceComponent implements OnInit {

  @Input() service: ProfessionalServiceRessource;
  @Input() from = false;
  @Input() boxable: boolean;
  public priceType = ProfessionalServicePriceType;

  constructor() { }

  ngOnInit(): void {
    this.boxable = this.boxable !== undefined ? this.boxable : this.service.boxable;
  }

}
